module.exports = __webpack_public_path__ + "static/media/05-ten-golden-rules.18de8730.png";